module.exports = __webpack_public_path__ + "static/media/i-add-circle-blue.1e05246b.svg";